<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-sm-12 ml-auto mr-auto">
        <nav>
          <div class="nav nav-tabs" id="nav-tab">
            <a
              class="nav-item nav-link"
              :class="menu == 1 ? 'active' : ''"
              @click="menu = 1"
              >Abonos</a
            >
            <a
              v-if="config.bancoHora"
              class="nav-item nav-link"
              :class="menu == 2 ? 'active' : ''"
              @click="menu = 2"
              >Banco de Horas</a
            >
          </div>
        </nav>
        <!--ABONOS-->
        <card v-show="menu == 1" card-body-classes="table-full-width">
          <div class="row m-0 p-0">
            <div class="col-sm-12 pr-2 pl-2">
              <el-select
                label="Hora"
                class="select-primary w-100"
                size="large"
                placeholder="Selecionar Abono"
                v-model="abono.tipo"
                :class="erros.tipo === true ? 'has-danger' : ''"
              >
                <el-option
                  v-for="option in listAbonos"
                  class="select-primary"
                  :value="option.id"
                  :label="option.descricao"
                  :key="option.descricao"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="row m-0 p-0">
            <div class="col-md-6 p-2 text-left">
              <base-input
                label="Data"
                type="date"
                placeholder="Data"
                v-model="abono.data"
                :class="erros.data === true ? 'has-danger' : ''"
                readonly
              >
              </base-input>
            </div>
            <div class="col-md-6 p-2 text-left">
              <base-input
                label="Qtde. de horas a abonar"
                type="time"
                placeholder="##:##"
                v-model="abono.hora"
                :class="erros.hora === true ? 'has-danger' : ''"
              >
              </base-input>
            </div>
          </div>

          <div class="row m-0 p-0">
            <file-upload
              class="col-12 m-1 p-1"
              @change="onFileChange"
              select-text="Selecione o arquivo"
              remove-text="Remover"
              change-text="Alterar arquivo"
            />
          </div>

          <div class="row m-0 p-0" v-if="abonos.length > 0">
            <div class="table-responsive mt-3">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Abonos</th>
                    <th scope="col">Hora</th>
                    <th scope="col">Anexo</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item of abonos" :key="item.id">
                    <td>{{ item.descricao }}</td>
                    <td>{{ item.horas }}</td>
                    <td role="button" @click="abrirFile(item.arquivo)">
                      {{ item.arquivo ? "Abrir Arquivo" : "Sem Arquivo" }}
                    </td>
                    <td>
                      <el-tooltip
                        content="Desabonar"
                        effect="light"
                        :open-delay="300"
                        placement="top"
                      >
                        <base-button
                          class="remove btn-link"
                          type="danger"
                          size="sm"
                          icon
                          @click="
                            carregarHorarios = true;
                            deletarAbono(item.id);
                          "
                        >
                          <i class="tim-icons icon-simple-remove"></i>
                        </base-button>
                      </el-tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row m-0 p-0">
            <div class="col-md-6 col-sm-6 p-2">
              <base-button
                @click="fecharModalAbono()"
                native-type="fail"
                type="danger"
                class="mb-3"
                size="lg"
                block
              >
                Fechar
              </base-button>
            </div>

            <div class="col-md-6 col-sm-6 p-2">
              <base-button
                @click="enviarAbono()"
                native-type="submit"
                type="success"
                class="mb-3"
                size="lg"
                block
              >
                Enviar Abono
              </base-button>
            </div>
          </div>
        </card>

        <!--BANCO DE HORAS-->
        <card v-show="menu == 2" card-body-classes="table-full-width">
          <div class="row m-0 p-0">
            <div class="col-sm-12 pr-2 pl-2">
              <el-select
                label="Hora"
                class="select-primary w-100"
                size="large"
                placeholder="Selecionar Tipo"
                v-model="abonoBH.tipo"
                :class="errosBH.tipo === true ? 'has-danger' : ''"
              >
                <el-option
                  v-for="option in listAbonosBH"
                  class="select-primary"
                  :value="option.id"
                  :label="option.descricao"
                  :key="option.descricao"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="row m-0 p-0">
            <div class="col-md-6 p-2 text-left">
              <base-input
                label="Data"
                type="date"
                placeholder="Data"
                v-model="abonoBH.data"
                :class="errosBH.data === true ? 'has-danger' : ''"
                readonly
              >
              </base-input>
            </div>
            <div class="col-md-6 p-2 text-left">
              <base-input
                label="Hora"
                type="time"
                placeholder="##:##"
                v-model="abonoBH.hora"
                :class="errosBH.hora === true ? 'has-danger' : ''"
              >
              </base-input>
            </div>
          </div>

          <!-- <div class="row m-0 p-0">
            <file-upload class="col-12 m-1 p-1" @change="onFileChange" select-text="Selecione o arquivo"
              remove-text="Remover" change-text="Alterar arquivo" />

          </div> -->

          <div class="row m-0 p-0" v-if="abonosBH.length > 0">
            <div class="table-responsive mt-3">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Abonos</th>
                    <th scope="col">Hora</th>
                    <!-- <th scope="col">Anexo</th> -->
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item of abonosBH" :key="item.id">
                    <td>{{ item.descricao }}</td>
                    <td>{{ item.horas }}</td>
                    <!-- <td role="button" @click="abrirFile(item.arquivo)">{{ item.arquivo ? 'Abrir Arquivo' : 'Sem Arquivo'
                    }}</td> -->
                    <td>
                      <el-tooltip
                        content="Desabonar"
                        effect="light"
                        :open-delay="300"
                        placement="top"
                      >
                        <base-button
                          class="remove btn-link"
                          type="danger"
                          size="sm"
                          icon
                          @click="
                            carregarHorarios = true;
                            deletarAbonoBH(item.id);
                          "
                        >
                          <i class="tim-icons icon-simple-remove"></i>
                        </base-button>
                      </el-tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row m-0 p-0">
            <div class="col-md-6 col-sm-6 p-2">
              <base-button
                @click="fecharModalAbono()"
                native-type="fail"
                type="danger"
                class="mb-3"
                size="lg"
                block
              >
                Fechar
              </base-button>
            </div>

            <div class="col-md-6 col-sm-6 p-2">
              <base-button
                @click="enviarAbonoBH()"
                native-type="submit"
                type="success"
                class="mb-3"
                size="lg"
                block
              >
                Enviar Abono
              </base-button>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BaseInput, FileUpload, ImageUpload } from "@/components/index";
import { Select, Option, TimeSelect, DatePicker } from "element-ui";
import swal from "sweetalert2";

export default {
  name: "AbonosInserir",
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    FileUpload,
    ImageUpload,
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseInput,
  },
  props: {
    dados: "",
    funcionario: "",
    config: "",
    matricula: "",
  },
  data() {
    return {
      menu: 1, // 1: abono, 2: banco de horas
      carregarHorarios: false, //controlar o emmit que dispara para carregar ou nao os horario da tela pai
      abonos: [],
      abonosBH: [],
      abono: {
        data: "",
        hora: "",
        tipo: "",
        file: null,
      },
      abonoBH: {
        tipo: "",
        data: "",
        hora: "",
        id_funcionario: "",
      },
      listAbonos: [],
      listAbonosBH: [],
      isLoading: false,
      erros: {
        data: "",
        hora: "",
        tipo: "",
        file: "",
      },
      errosBH: {
        data: "",
        hora: "",
        tipo: "",
      },
    };
  },
  created() {},
  mounted() {
    this.carregarDados();
  },
  methods: {
    base64ToArrayBuffer(data) {
      var bString = window.atob(data);
      var bLength = bString.length;
      var bytes = new Uint8Array(bLength);
      for (var i = 0; i < bLength; i++) {
        var ascii = bString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    base64toPDF(data) {
      var bufferArray = this.base64ToArrayBuffer(data);
      var blobStore = new Blob([bufferArray], { type: "application/pdf" });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobStore);
        return;
      }
      var data = window.URL.createObjectURL(blobStore);
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.href = data;
      link.download = "file.pdf";
      link.click();
      window.URL.revokeObjectURL(data);
      link.remove();
    },
    abrirFile(file) {
      if (file) {
        const type = file.split(";")[0].split("/")[1];
        if (type == "pdf") {
          const base64 = file.split(",")[1];
          this.base64toPDF(base64);
        } else {
          let image = new Image();
          image.src = file;
          var newTab = window.open();
          newTab.document.body.innerHTML = image.outerHTML;
        }
      }
    },
    carregarDados() {
      // carrega na tela
      this.abono.data = this.dados.day;
      this.abono.hora = this.dados.atrasos;
      // carrega dados
      this.listarTipoAbono();
      this.listarAbonos();

      if (this.config.bancoHora) {
        this.abonoBH.data = this.dados.day;
        // this.abonoBH.hora = '00:00';
        this.listarTipoAbonoBH();
        this.listarAbonosBH();
      }
    },
    deletarAbono(id) {
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_funcionario: this.funcionario,
        id_abono: id,
      };
      this.axios
        .post("/api/abonos/deletarAbonoFuncionario", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          if (response.data.data.status) {
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Abono deletado com sucesso!",
              "success",
            );
            th.listarAbonos();
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao deletar abono!",
              "error",
            );
          }
        })
        .catch((err) => {
          console.log(err);
          th.showSwal("auto-close", "Erro", "Erro ao deletar abono!", "error");
        });
    },
    deletarAbonoBH(id) {
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_funcionario: this.funcionario,
        id: id,
      };
      this.axios
        .post("/api/abonosBH/deletar", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Abono deletado com sucesso!",
              "success",
            );
            th.listarAbonosBH();
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao deletar abono de banco de horas!",
              "error",
            );
          }
        })
        .catch((err) => {
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao deletar abono de banco de horas!",
            "error",
          );
        });
    },
    listarAbonos() {
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_empregado: this.funcionario,
        dataInicial: this.dados.day,
        dataFinal: this.dados.day,
        matricula: this.matricula,
      };
      th.isLoading = true;
      this.axios
        .post("/api/abonos/listarPeriodoAbonosPorIdEmpregado", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.abonos = response.data.data.dados;
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar abonos!",
            "error",
          );
        });
    },
    listarAbonosBH() {
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_funcionario: this.funcionario,
        data_inicial: this.dados.day,
        data_final: this.dados.day,
        matricula: this.matricula,
      };
      th.isLoading = true;
      this.axios
        .post("/api/abonosBH/listarPorPeriodo", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.abonosBH = response.data.data;
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar abonos!",
            "error",
          );
        });
    },
    listarTipoAbono() {
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        ativo: "S",
      };

      this.axios
        .post("/api/abonos/listarTiposDeAbonos", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.listAbonos = response.data.data.dados;
        })
        .catch((err) => {
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar tipos de abonos!",
            "error",
          );
        });
    },

    listarTipoAbonoBH() {
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/abonosBH/listarTiposDeAbonos", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.listAbonosBH = response.data.data;
        })
        .catch((err) => {
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar tipos de abonos de banco de dados!",
            "error",
          );
        });
    },
    enviarAbonoBH() {
      const th = this;

      if (this.validarDadosBH()) {
        this.isLoading = true;
        const formData = {
          setDB: this.$cookies.get("db"),
          id_funcionario: this.funcionario,
          tipo: this.abonoBH.tipo,
          data: this.moment(this.abonoBH.data).format("YYYY-MM-DD"),
          hora: this.abonoBH.hora ? this.abonoBH.hora + `:00` : "",
          matricula: this.matricula,
        };

        this.axios
          .post("/api/abonosBH/criar", formData, {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          })
          .then(() => {
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Abono inserido com sucesso!",
              "success",
            );
            th.carregarHorarios = true;
            th.fecharModalAbono();
          })
          .catch((err) => {
            console.log(err);
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao enviar solicitação!",
              "error",
            );
          });
      } else {
        this.showSwal(
          "auto-close",
          "Erro",
          "Você precisa preencher todos os campos",
          "error",
        );
      }
    },
    enviarAbono() {
      const th = this;

      if (this.validarDados()) {
        this.isLoading = true;
        const formData = {
          setDB: this.$cookies.get("db"),
          id_funcionario: this.funcionario,
          id_tipo_abono: this.abono.tipo,
          data: this.moment(this.abono.data).format("DD/MM/YYYY"),
          horas: this.abono.hora ? this.abono.hora + `:00` : "",
          arquivo: this.abono.file,
          status_abono: "S", //aprovado
          modo_abono: 2,
          matricula: this.matricula,
        };

        this.axios
          .post("/api/abonos/inserirAbonoFuncionario", formData, {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          })
          .then(() => {
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Abono inserido com sucesso!",
              "success",
            );
            th.carregarHorarios = true;
            th.fecharModalAbono();
          })
          .catch((err) => {
            console.log(err);
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao enviar solicitação!",
              "error",
            );
          });
      } else {
        this.showSwal(
          "auto-close",
          "Erro",
          "Você precisa preencher todos os campos",
          "error",
        );
      }
    },
    validarDados() {
      let status = true;

      if (this.abono.data && this.abono.data !== "") {
        this.erros.data = false;
      } else {
        this.erros.data = true;
        status = false;
      }

      if (this.abono.hora && this.abono.hora !== "") {
        this.erros.hora = false;
      } else {
        this.erros.hora = true;
        status = false;
      }

      if (this.abono.tipo) {
        this.erros.tipo = false;
      } else {
        this.erros.tipo = true;
        status = false;
      }

      return status;
    },
    validarDadosBH() {
      let status = true;

      if (this.abonoBH.data && this.abonoBH.data !== "") {
        this.errosBH.data = false;
      } else {
        this.errosBH.data = true;
        status = false;
      }

      if (this.abonoBH.hora && this.abonoBH.hora !== "") {
        this.errosBH.hora = false;
      } else {
        this.errosBH.hora = true;
        status = false;
      }

      if (this.abonoBH.tipo) {
        this.errosBH.tipo = false;
      } else {
        this.errosBH.tipo = true;
        status = false;
      }

      return status;
    },
    fecharModalAbono() {
      this.$emit("fecharModalAbono", this.carregarHorarios);
    },
    onFileChange(file) {
      if (file) {
        this.abono.file = file;
      } else {
        this.abono.file = "";
      }
    },
    moment: function(data) {
      return moment(data);
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
  },
};
</script>
<style>
.nav-tabs .nav-link.active {
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
  cursor: pointer;
}

.nav-link:hover {
  cursor: pointer;
}

.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Escolher";
}

.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
